import { Strategy as StrategyType } from '../utils'
import Styles from './CustomizeTable.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { CountInput } from 'components/Wizards/CountInput/CountInput'
import cx from 'classnames'
import { useHover } from '@react-aria/interactions'
import { Document, Trash2 } from 'blaze-ui/icons/20'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { BlogPlatformSelect } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/BrandPlanTactics'
import { useEffect, useState } from 'react'
import { BrandPlanTactic, SelectedBlogPlatform } from 'types'
import { uniq } from 'lodash'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Heading } from 'blaze-ui/Heading/Heading'
export interface BlogRowProps {
  strategy: StrategyType
  onUpdate: (strategy: StrategyType) => void
  selectedBlogPlatform: SelectedBlogPlatform
  setSelectedBlogPlatform: (platform: SelectedBlogPlatform) => void
  isDisabled?: boolean
}

export const BlogRow = ({
  strategy,
  onUpdate,
  selectedBlogPlatform,
  setSelectedBlogPlatform,
  isDisabled,
}: BlogRowProps) => {
  const wixEnabled = useFlipperFlag('wix_blog_integration')
  const shopifyEnabled = useFlipperFlag('shopify_integration')
  const [isSeoSelected, setIsSeoSelected] = useState<boolean>(true)
  const { isMobile } = useResponsiveDesign()
  const { hoverProps, isHovered } = useHover({})
  const seoContentsCount = strategy.seo_contents.find((content) => content.type === 'blog_post')?.count || 0

  useEffect(() => {
    if (seoContentsCount > 0 && !isSeoSelected) {
      setIsSeoSelected(true)
      setSelectedBlogPlatform(selectedBlogPlatform)
    }
  }, [seoContentsCount, isSeoSelected, setSelectedBlogPlatform, selectedBlogPlatform])

  return (
    <div className={Styles.customizeContentRow} {...hoverProps}>
      <div className={Styles.customizeContentRowItem}>
        <Document size={20} color="rgba(32, 161, 79, 1)" />
        {isMobile ? <Heading level={5}>Blog</Heading> : <Text>Blog</Text>}
      </div>
      <div
        className={cx(Styles.customizeContentRowItem, Styles.settingRowItem, {
          [Styles.disabled]: seoContentsCount === 0,
        })}
      >
        {isMobile && <Text>Channels</Text>}
        <BlogPlatformSelect
          isSelected={isSeoSelected}
          selectedPlatform={selectedBlogPlatform}
          onSelectionChange={(selected) => {
            if (!selected) {
              onUpdate({
                ...strategy,
                seo_contents: [{ type: 'blog_post', count: 0 }],
                tactics: strategy.tactics.filter((tactic) => tactic !== BrandPlanTactic.SEO),
              })
            }
            setIsSeoSelected(selected)
          }}
          onPlatformChange={(platform) => {
            setSelectedBlogPlatform(platform)
          }}
          wixEnabled={wixEnabled}
          shopifyEnabled={shopifyEnabled}
          showOnlyDropdown
          size="md"
          isDisabled={seoContentsCount === 0}
          allowNone={!isDisabled}
        />
      </div>
      <div className={cx(Styles.customizeContentRowItem, Styles.settingRowItem)}>
        {isMobile && <Text>Posts per week</Text>}
        <CountInput
          name="seo_contents"
          value={seoContentsCount || 0}
          onChange={(value) => {
            onUpdate({
              ...strategy,
              seo_contents: [{ type: 'blog_post', count: value }],
              tactics:
                value > 0
                  ? uniq([...strategy.tactics, BrandPlanTactic.SEO])
                  : strategy.tactics.filter((tactic) => tactic !== BrandPlanTactic.SEO),
            })
          }}
          min={isDisabled ? 1 : 0}
          size="sm"
          buttonSize="sm"
          className={Styles.countInput}
        />
      </div>
      {!isMobile && (
      <div
        className={cx(Styles.customizeContentRowItem, Styles.actionRowItem, {
          [Styles.visible]: isHovered && seoContentsCount > 0,
        })}
      >
        <IconButton
          icon={Trash2}
          variant="tertiary"
          isDisabled={isDisabled}
          onPress={() => {
            onUpdate({
              ...strategy,
              seo_contents: [{ type: 'blog_post', count: 0 }],
            })
          }}
        />
      </div>
      )}
    </div>
  )
}
